import 'shared/global';

import 'components/hero.js';
import 'components/accessibilityCarousel.js';
import portraitCarousel from 'components/portraitCarousel';
import whatsnew from 'components/whatsnewHybrid';
import lightning from 'components/lightning';
import about from 'shows/about';
import rainMaker from 'shows/rainMaker';
import sportSchedule from 'shows/sportSchedule';
import 'components/subnav';
import gridAndCarousels from 'video/gridAndCarousels';
import 'shows/parentalControlsPin.js';
import liveEventGridView from 'components/liveEventGridView';
import WatchlistCta from 'components/watchlist/WatchlistCta';
import PreferencesCta from 'components/preferences/PreferencesCta';

const brazeCampaignParams = { screenName: 'show detail' };

try {
    new WatchlistCta();
} catch (e) {
    console.error('Watchlist cta failed to load', e);
}

try {
    new PreferencesCta();
} catch (e) {
    console.error('Preferences cta failed to load', e);
}

try {
    gridAndCarousels(
        CBS.Registry.region.prefix +
            '/shows/{slug}/xhr/episodes/page/{page}/size/{size}/xs/{excludeShow}/season/{season}/',
        CBS.Registry.region.prefix +
            '/shows/{slug}/xhr/sectionId/{sectionId}/offset/{offset}/limit/{limit}/xs/0/'
    );
} catch (e) {
    console.error('Video below the fold failed to load', e);
}

try {
    portraitCarousel({
        parentContainer: $('#js-cast')
    });
} catch (e) {
    console.error('Cast failed to load', e);
}

try {
    portraitCarousel({
        parentContainer: $('#related-shows-carousel')
    });
} catch (e) {
    console.error('Related Shows failed to load', e);
}

try {
    portraitCarousel({
        parentContainer: $('#guests-carousel')
    });
} catch (e) {
    console.error('Guests failed to load', e);
}

try {
    let whatsnewCarouselMount = $('#whatsnew-carousel');
    whatsnew({
        carousel: {
            parentContainer: whatsnewCarouselMount,
            options: {
                endPoint: '/shows/{slug}/xhr/whats-new/offset/{offset}/limit/{limit}/',
                params: {
                    slug: whatsnewCarouselMount.data('slug')
                }
            }
        },
        grid: {
            parentContainer: $('#whatsnew-grid'),
            options: {
                endPoint: '/shows/{slug}/xhr/whats-new/offset/{offset}/limit/{limit}/'
            }
        }
    });
} catch (e) {
    console.error("What's New failed to load", e);
}

// What's New NFL

try {
    let whatsnewCarouselMountNFL = $('#whatsnew-carousel-nfl');
    whatsnew({
        carousel: {
            parentContainer: whatsnewCarouselMountNFL,
            options: {
                endPoint: '/shows/{slug}/xhr/whats-new-nfl/offset/{offset}/limit/{limit}/',
                params: {
                    slug: whatsnewCarouselMountNFL.data('slug')
                }
            }
        },
        grid: {
            parentContainer: $('#whatsnew-grid-nfl'),
            options: {
                endPoint: '/shows/{slug}/xhr/whats-new-nfl/offset/{offset}/limit/{limit}/'
            }
        }
    });
} catch (e) {
    console.error("What's New NFL failed to load", e);
}

// What's New NCAA
try {
    let whatsnewCarouselMountNCAA = $('#whatsnew-carousel-ncaa');
    whatsnew({
        carousel: {
            parentContainer: whatsnewCarouselMountNCAA,
            options: {
                endPoint: '/shows/{slug}/xhr/whats-new-ncaa/offset/{offset}/limit/{limit}/',
                params: {
                    slug: whatsnewCarouselMountNCAA.data('slug')
                }
            }
        },
        grid: {
            parentContainer: $('#whatsnew-grid-ncaa'),
            options: {
                endPoint: '/shows/{slug}/xhr/whats-new-ncaa/offset/{offset}/limit/{limit}/'
            }
        }
    });
} catch (e) {
    console.error("What's New NCAA failed to load", e);
}

// What's New SEC
try {
    let whatsnewCarouselMountSEC = $('#whatsnew-carousel-sec');
    whatsnew({
        carousel: {
            parentContainer: whatsnewCarouselMountSEC,
            options: {
                endPoint: '/shows/{slug}/xhr/whats-new-sec/offset/{offset}/limit/{limit}/',
                params: {
                    slug: whatsnewCarouselMountSEC.data('slug')
                }
            }
        },
        grid: {
            parentContainer: $('#whatsnew-grid-sec'),
            options: {
                endPoint: '/shows/{slug}/xhr/whats-new-sec/offset/{offset}/limit/{limit}/'
            }
        }
    });
} catch (e) {
    console.error("What's New SEC failed to load", e);
}

// What's New Hockey East
try {
    let whatsnewCarouselMountHockeyEast = $('#whatsnew-carousel-hockey-east');
    whatsnew({
        carousel: {
            parentContainer: whatsnewCarouselMountHockeyEast,
            options: {
                endPoint: '/shows/{slug}/xhr/whats-new-hockey-east/offset/{offset}/limit/{limit}/',
                params: {
                    slug: whatsnewCarouselMountHockeyEast.data('slug')
                }
            }
        },
        grid: {
            parentContainer: $('#whatsnew-grid-hockey-east'),
            options: {
                endPoint: '/shows/{slug}/xhr/whats-new-hockey-east/offset/{offset}/limit/{limit}/'
            }
        }
    });
} catch (e) {
    console.error("What's New Hockey East failed to load", e);
}

// What's New NWSL
try {
    let whatsnewCarouselMountNWSL = $('#whatsnew-carousel-nwsl');
    whatsnew({
        carousel: {
            parentContainer: whatsnewCarouselMountNWSL,
            options: {
                endPoint: '/shows/{slug}/xhr/whats-new-nwsl/offset/{offset}/limit/{limit}/',
                params: {
                    slug: whatsnewCarouselMountNWSL.data('slug')
                }
            }
        },
        grid: {
            parentContainer: $('#whatsnew-grid-nwsl'),
            options: {
                endPoint: '/shows/{slug}/xhr/whats-new-nwsl/offset/{offset}/limit/{limit}/'
            }
        }
    });
} catch (e) {
    console.error("What's New NWSL failed to load", e);
}

// What's New The Masters
try {
    let whatsnewCarouselMountMasters = $('#whatsnew-carousel-masters');
    whatsnew({
        carousel: {
            parentContainer: whatsnewCarouselMountMasters,
            options: {
                endPoint: '/shows/{slug}/xhr/whats-new-masters/offset/{offset}/limit/{limit}/',
                params: {
                    slug: whatsnewCarouselMountMasters.data('slug')
                }
            }
        },
        grid: {
            parentContainer: $('#whatsnew-grid-masters'),
            options: {
                endPoint: '/shows/{slug}/xhr/whats-new-masters/offset/{offset}/limit/{limit}/'
            }
        }
    });
} catch (e) {
    console.error("What's New The Masters failed to load", e);
}

try {
    liveEventGridView({
        useTemplate: 'liveEventTpl',
        parentContainer: $('#live-events-grid'),
        options: {
            endPoint: '/shows/{slug}/xhr/live-events/offset/{offset}/limit/{limit}/'
        }
    });
} catch (e) {
    console.error('Guests failed to load', e);
}

try {
    let lightningMount = $('#lightning-carousel');
    lightning({
        parentContainer: lightningMount,
        options: {
            endPoint: '/shows/{slug}/xhr/lightning/offset/{offset}/limit/{limit}/',
            params: {
                slug: lightningMount.data('slug')
            }
        }
    });
} catch (e) {
    console.error('Lightning failed to load', e);
}

try {
    let classicMount = $('#classics-carousel');
    portraitCarousel({
        parentContainer: classicMount,
        options: {
            useBuffer: false,
            endPoint: '/shows/{slug}/xhr/other-favorites/5/',
            params: {
                slug: classicMount.data('slug')
            }
        }
    });
} catch (e) {
    console.error('Classics failed to load', e);
}

try {
    about();
} catch (e) {
    console.error('About failed to load', e);
}

try {
    rainMaker();
} catch (e) {
    console.error('Rainmaker failed to load', e);
}

try {
    sportSchedule();
} catch (e) {
    console.error('Sport Schedule failed to load', e);
}

// Trigger braze event for show home page view
if (CBS.Registry.Show && CBS.Registry.Features.braze_sdk === true) {
    import('shared/braze_events/events').then(({ onShowMoviePageView }) => {
        brazeCampaignParams['showName'] = CBS.Registry.Show.name;
        onShowMoviePageView(CBS.Registry.Show.name, brazeCampaignParams);
    });
}

async function createSubNavForReactTopNav() {
    // Find the hidden input
    const input = document.getElementById('subnav-items');
    if (!input) return;

    // check if input.value string contains &quot; and replace with "
    let subnavData = input.value.replace(/&quot;/g, '"').replace(/\\/g, '');
    
    // Parse JSON value
    try {
        subnavData = JSON.parse(subnavData);
    } catch (e) {
        console.error('Invalid JSON in #subnav-items');
        return;
    }

    // Build subnav HTML
    const subnav = document.createElement('div');
    subnav.id = 'subnav';
    subnav.className = 'padded-container has-arrows';

    subnav.innerHTML = `
        <div class="line"></div>
        <div class="nav-prev"></div>
        <ul data-ci="subnav" class="subnav__items" aa-region="${subnavData.aaRegion}">
            ${subnavData.items.map((item, idx) => `
                <li>
                    <a
                        class="${idx === 0 ? 'active': ''}"
                        aria-label="${item.title}"
                        href="${item.href}"
                        aa-link="${item.aaLink}"
                    >
                        ${item.title}
                    </a>
                </li>
            `).join('')}
        </ul>
        <div class="nav-next"></div>
    `;

    // Insert subnav into topNav component
    const existing = document.getElementById('subnav');
    if (!existing) {
        waitForSubNavContainerAndAppend(subnav);
    }
}

function waitForSubNavContainerAndAppend(subnav) {
    let counter = 0;
    const interval = setInterval(() => {
        counter++;
        const subNavContainer = document.getElementById('header-sub-nav');
        if (subNavContainer) {
            subNavContainer.appendChild(subnav);
            clearInterval(interval);
        } else if (counter >= 50) {
            clearInterval(interval);
        }
    }, 100);
}

if (CBS.Registry.Features.react_web_components_enabled === true
    && CBS.Registry.Features.react_web_components_topnav === true) {
    createSubNavForReactTopNav();
}
